import {Injectable} from '@angular/core';
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {ModeratBackendService} from "./backend.service";
import {Router} from "@angular/router";
import {PortalService} from "../../services/portal.service";
import {EmbedService} from "../../services/embed.service";
import {RequestService} from "../../services/request.service";
import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class ModeratRequestService extends RequestService {

  /**
   * @inheritdoc
   */
  requestObjectName = 'moc-anfrage';

  /**
   * constructor.
   */
  constructor(public backendService: ModeratBackendService, private router: Router,
              protected portalService: PortalService, protected embedService: EmbedService) {
    super(backendService, portalService, embedService);

    try {
      // preset and redirect only if we are inside the moc
      if (typeof advisorObjectData === "object" && typeof localStorage === "object" && window.location.href.indexOf('moderat') > -1) {
        // save injected data
        localStorage.setItem('moc-anfrage', JSON.stringify(advisorObjectData));
        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/moderat/sanierung/massnahmen']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new ModeratAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): ModeratAnfrage {
    return super.getAnfrage() as ModeratAnfrage;
  }
}
